import { Row } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { ChevronRight } from '@assets/icons';

import {
  Content,
  StyledImage,
  BottomInfo,
  BottomInfoContainer,
  TextWrapper,
  ImageWrapper,
} from './styled';

export interface Props {
  title: string;
  image: {
    url: string;
    alt?: string;
  };
  url: string;
}

const IslandItem = ({ title, image, url }: Props) => {
  return (
    <Content onClick={() => window.open(url, '_blank', 'noopener, noreferrer')}>
      <ImageWrapper>
        <StyledImage
          src={image?.url ?? ''}
          alt={image?.alt ?? 'setur'}
          width={300}
          height={300}
        />
      </ImageWrapper>

      <BottomInfoContainer>
        <BottomInfo>
          <Row
            alignItems='center'
            justifyContent='space-between'
            style={{ marginTop: '5px' }}
          >
            <TextWrapper
              onClick={() => window.open(url, '_blank', 'noopener, noreferrer')}
            >
              {title}
            </TextWrapper>
            <CustomIcon
              icon={ChevronRight}
              width={16}
              height={16}
              paletteColor='lightGray'
              onClick={() => window.open(url, '_blank', 'noopener, noreferrer')}
            />
          </Row>
        </BottomInfo>
      </BottomInfoContainer>
    </Content>
  );
};

export default IslandItem;
